import React from "react";
import style from "../Footer/Footer.module.css";



const Footer = () => {
    return (
   
        <div className={style.container}>
        <h3>By Cristina Gómez</h3> 
          </div>
    )};
    export default Footer;